import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { OpenModalContainer } from '../../components/openModalContainer';
import { clearEntryScene } from '../../redux/actions/gameEntryActions';
import { useAppDispatch } from '../../redux/store';
import { assertUnreachable } from '../../utils/tsUtils';
export const GameEntryDialog = ({ gameEntryDialogProperties }) => {
    const dispatch = useAppDispatch();
    const { title, message, buttons } = gameEntryDialogProperties;
    return (_jsxs(OpenModalContainer, { title: title, children: [_jsx(DialogContent, { children: _jsx(DialogContentText, { children: message }) }), _jsx(DialogActions, { children: buttons.map((button, i) => {
                    return (_jsx(Button, { variant: 'contained', onClick: () => {
                            switch (button.actionType) {
                                case 'verify_done': {
                                    dispatch(clearEntryScene());
                                    break;
                                }
                                default: {
                                    assertUnreachable(button.actionType);
                                }
                            }
                        }, children: button.label }, i));
                }) })] }));
};
